import { useHandleSignInCallback } from '@logto/react'
import { useNavigate } from 'react-router-dom'
import LoadingSpinner from '@/components/LoadingSpinner'
import './CallbackPage.css'

const CallbackPage = () => {
  const navigate = useNavigate()
  
  const { isLoading } = useHandleSignInCallback(() => {
    // Redirect to home page when callback is complete
    navigate('/', { replace: true })
  })

  // Show loading while processing callback
  if (isLoading) {
    return (
      <div className="callback-page">
        <div className="container">
          <div className="callback-content">
            <div className="callback-card">
              <LoadingSpinner size="large" />
              <h2 className="callback-title">Authenticating...</h2>
              <p className="callback-message">Processing authentication...</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return null
}

export default CallbackPage 